import { useEffect, useState } from "react";
import { fetchSpecialDays, specialFor, toMin } from "../lib/hours";

// Öffnungszeiten: Mo–Sa 16:00–02:00, So 12:00–01:00 (Minuten seit Mitternacht, Ende kann > 24h liegen)
const HOURS = {
  0: [12 * 60, 25 * 60], // So
  1: [16 * 60, 26 * 60],
  2: [16 * 60, 26 * 60],
  3: [16 * 60, 26 * 60],
  4: [16 * 60, 26 * 60],
  5: [16 * 60, 26 * 60],
  6: [16 * 60, 26 * 60],
};
const DAY_NAMES = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
const fmt = (mins) => {
  const m = mins % (24 * 60);
  return `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;
};

const addDays = (d, n) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + n, d.getHours(), d.getMinutes());

// Sonderzeiten (aus der Datenbank) überschreiben die normalen Zeiten; Ruhetag -> null
const hoursFor = (days, d) => {
  const sp = specialFor(days, d);
  if (sp) {
    if (sp.kind === "closed") return null;
    let s = toMin(sp.open);
    let e = toMin(sp.close);
    if (e <= s) e += 24 * 60;
    return [s, e];
  }
  return HOURS[d.getDay()];
};

const getStatus = (now, days) => {
  const mins = now.getHours() * 60 + now.getMinutes();

  const today = hoursFor(days, now);
  if (today) {
    const [s, e] = today;
    if (mins >= s && mins < e) return { state: "open", label: `Jetzt geöffnet · bis ${fmt(e)} Uhr` };
  }

  const yesterday = hoursFor(days, addDays(now, -1));
  if (yesterday) {
    const [, ye] = yesterday;
    if (ye > 24 * 60 && mins < ye - 24 * 60)
      return { state: "open", label: `Jetzt geöffnet · bis ${fmt(ye)} Uhr` };
  }

  for (let i = 0; i < 8; i++) {
    const d = addDays(now, i);
    const h = hoursFor(days, d);
    if (!h) continue;
    const [ns] = h;
    if (i === 0 && mins >= ns) continue;
    const prefix = i === 0 ? "heute" : i === 1 ? "morgen" : DAY_NAMES[d.getDay()];
    return { state: "closed", label: `Geschlossen · öffnet ${prefix} ${fmt(ns)} Uhr` };
  }
  return { state: "closed", label: "Geschlossen" };
};

export const OpenBadge = ({ className = "" }) => {
  const [days, setDays] = useState([]);
  const [status, setStatus] = useState(() => getStatus(new Date(), []));

  useEffect(() => {
    fetchSpecialDays().then(setDays);
  }, []);

  useEffect(() => {
    setStatus(getStatus(new Date(), days));
    const id = setInterval(() => setStatus(getStatus(new Date(), days)), 30000);
    return () => clearInterval(id);
  }, [days]);

  const dot = status.state === "open" ? "bg-emerald-400" : "bg-red-400/80";

  return (
    <span
      data-testid="open-badge"
      data-state={status.state}
      className={`inline-flex items-center gap-2 rounded-full border border-gold/30 bg-teal-deep/80 px-4 py-1.5 text-xs tracking-wide text-cream/85 ${className}`}
    >
      <span className="relative flex h-2 w-2">
        <span className={`absolute inline-flex h-full w-full rounded-full ${dot} opacity-60 animate-ping`} />
        <span className={`relative inline-flex h-2 w-2 rounded-full ${dot}`} />
      </span>
      {status.label}
    </span>
  );
};
